import { VaihtoetuLanding } from '../../../components/Vaihtoetu/VaihtoetuLanding';

export const VaihtoetuPath = () => {
  return <VaihtoetuLanding />;
};
